import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { Loader2, Pencil } from 'lucide-react';
import { toast } from 'sonner';
import { errMsg } from '../guias/guiasUtils';

const brl = (v) => (v == null ? '—' : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));

const parseNum = (s) => parseFloat(String(s).replace(/\./g, '').replace(',', '.'));

export const EditarValorUnitarioDialog = ({ api, lanc, onClose, onSaved }) => {
  const [valor, setValor] = useState('');
  const [just, setJust] = useState('');
  const [atualizar, setAtualizar] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (lanc) { setValor(''); setJust(''); setAtualizar(true); } }, [lanc]);
  if (!lanc) return null;
  const novo = parseNum(valor);
  const valido = !Number.isNaN(novo) && novo >= 0 && just.trim().length >= 5;

  const salvar = async () => {
    setBusy(true);
    try {
      const r = await api.put(`/auditoria-financeira/itens/${lanc.item_id}/valor-unitario`, { valor_antigo: lanc.custo_unitario, valor_novo: novo, justificativa: just.trim(), atualizar_custo_medio: atualizar });
      toast.success(`${lanc.item}: ${r.data.movimentacoes_recalculadas} lançamento(s) em ${r.data.internacoes_afetadas} paciente(s) atualizados para ${brl(novo)}`);
      onSaved?.(); onClose();
    } catch (e) { toast.error(errMsg(e, 'Erro ao editar valor unitário')); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!lanc} onOpenChange={(o) => { if (!o && !busy) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="dialog-editar-valor-unitario">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Pencil className="h-4 w-4" /> Editar valor unitário</DialogTitle>
          <DialogDescription>{lanc.item} · unitário atual <strong>{brl(lanc.custo_unitario)}</strong></DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <div className="space-y-1">
            <Label className="text-sm">Novo valor unitário (R$) *</Label>
            <Input inputMode="decimal" placeholder="Ex.: 3,833" value={valor} onChange={(e) => setValor(e.target.value)} data-testid="input-novo-valor-unitario" />
            {valor && !Number.isNaN(novo) && lanc.quantidade ? <p className="text-xs text-muted-foreground" data-testid="preview-total">Este lançamento: {lanc.quantidade} × {brl(novo)} = <strong>{brl(novo * lanc.quantidade)}</strong></p> : null}
          </div>
          <div className="space-y-1">
            <Label className="text-sm">Justificativa *</Label>
            <Textarea rows={2} value={just} onChange={(e) => setJust(e.target.value)} placeholder="Ex.: valor da caixa (30 cp) lançado como unitário" data-testid="input-justificativa-valor" />
          </div>
          <label className="flex items-start gap-2 text-sm cursor-pointer">
            <Checkbox checked={atualizar} onCheckedChange={(v) => setAtualizar(!!v)} data-testid="check-atualizar-custo-medio" />
            <span>Atualizar também o custo atual do item no estoque (novas dispensações usarão {valor && !Number.isNaN(novo) ? brl(novo) : 'o novo valor'})</span>
          </label>
          <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded p-2" data-testid="aviso-abrangencia">
            A alteração vale para <strong>todos os pacientes</strong>: todo lançamento de <strong>{lanc.item}</strong> com unitário {brl(lanc.custo_unitario)} passa para o novo valor (quantidades e datas preservadas; valor anterior fica no histórico).
          </p>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={busy} data-testid="btn-cancelar-valor">Cancelar</Button>
          <Button onClick={salvar} disabled={!valido || busy} data-testid="btn-salvar-valor-unitario">{busy && <Loader2 className="h-4 w-4 animate-spin mr-1" />} Aplicar a todos</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
